"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _en = _interopRequireDefault(require("./en.json"));
var _id = _interopRequireDefault(require("./id.json"));
var _fr = _interopRequireDefault(require("./fr.json"));
var _enId = _interopRequireDefault(require("./en-id.json"));
var _enIn = _interopRequireDefault(require("./en-in.json"));
var _enMy = _interopRequireDefault(require("./en-my.json"));
var _enPh = _interopRequireDefault(require("./en-ph.json"));
var _enTh = _interopRequireDefault(require("./en-th.json"));
var _esAr = _interopRequireDefault(require("./es-ar.json"));
var _esCL = _interopRequireDefault(require("./es-CL.json"));
var _esCO = _interopRequireDefault(require("./es-CO.json"));
var _esES = _interopRequireDefault(require("./es-ES.json"));
var _esMX = _interopRequireDefault(require("./es-MX.json"));
var _msMy = _interopRequireDefault(require("./ms-my.json"));
var _pl = _interopRequireDefault(require("./pl.json"));
var _ptBR = _interopRequireDefault(require("./pt-BR.json"));
var _th = _interopRequireDefault(require("./th.json"));
var _vi = _interopRequireDefault(require("./vi.json"));
var _zhHans = _interopRequireDefault(require("./zh-Hans.json"));
var _zhHant = _interopRequireDefault(require("./zh-Hant.json"));
var _default = {
  en: _en.default,
  // 英语
  'en-my': _enMy.default,
  'en-id': _enId.default,
  'en-in': _enIn.default,
  'en-ph': _enPh.default,
  'en-th': _enTh.default,
  'es-ar': _esAr.default,
  'es-CL': _esCL.default,
  'es-CO': _esCO.default,
  'es-ES': _esES.default,
  'es-MX': _esMX.default,
  fr: _fr.default,
  id: _id.default,
  'ms-my': _msMy.default,
  pl: _pl.default,
  'pt-BR': _ptBR.default,
  th: _th.default,
  vi: _vi.default,
  'zh-Hans': _zhHans.default,
  'zh-Hant': _zhHant.default
};
exports.default = _default;